<label class="group-text" for="">
  <h3>{{ title }}</h3>
  <input
    (input)="valueTexbox = $event.target.value"
    type="{{ type }}"
    name=""
    id=""
  />
</label>
